export enum submissionGroupActionTypes {
  SET_SUBMISSION_GROUPS = 'SET_SUBMISSION_GROUPS',
  CREATE_GROUP_LOADING = 'CREATE_GROUP_LOADING',
  UPDATE_GROUP_LOADING = 'UPDATE_GROUP_LOADING',
  DELETE_GROUP_LOADING = 'DELETE_GROUP_LOADING',
  SET_ALL_SUBMISSION_GROUPS = 'SET_ALL_SUBMISSION_GROUPS',
}
